module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/44a71e47e7da9c14b0feb31028c281e5.png";